import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from '@/components/ui/chart';
import { Line, LineChart, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer } from 'recharts';
import { format } from 'date-fns';

interface RatingTrendChartProps {
  data: {
    month: string;
    avg_safety: number;
    avg_quality: number;
    avg_reliability: number;
    avg_overall: number;
  }[];
}

export function RatingTrendChart({ data }: RatingTrendChartProps) {
  const formattedData = data.map(item => ({
    ...item,
    month: format(new Date(item.month), 'MMM yyyy'),
  }));

  const chartConfig = {
    avg_safety: {
      label: 'Safety',
      color: 'hsl(var(--chart-1))',
    },
    avg_quality: {
      label: 'Quality',
      color: 'hsl(var(--chart-2))',
    },
    avg_reliability: {
      label: 'Reliability',
      color: 'hsl(var(--chart-3))',
    },
    avg_overall: {
      label: 'Overall',
      color: 'hsl(var(--chart-4))',
    },
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>Rating Trends Over Time</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer config={chartConfig} className="h-[400px]">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={formattedData}>
              <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
              <XAxis 
                dataKey="month" 
                className="text-xs"
                tick={{ fill: 'hsl(var(--foreground))' }}
              />
              <YAxis 
                domain={[0, 5]} 
                className="text-xs"
                tick={{ fill: 'hsl(var(--foreground))' }}
              />
              <ChartTooltip content={<ChartTooltipContent />} />
              <Legend />
              <Line 
                type="monotone" 
                dataKey="avg_safety" 
                stroke="var(--color-avg_safety)" 
                name="Safety"
                strokeWidth={2}
              />
              <Line 
                type="monotone" 
                dataKey="avg_quality" 
                stroke="var(--color-avg_quality)" 
                name="Quality"
                strokeWidth={2}
              />
              <Line 
                type="monotone" 
                dataKey="avg_reliability" 
                stroke="var(--color-avg_reliability)" 
                name="Reliability"
                strokeWidth={2}
              />
              <Line 
                type="monotone" 
                dataKey="avg_overall" 
                stroke="var(--color-avg_overall)" 
                name="Overall"
                strokeWidth={2}
                strokeDasharray="5 5"
              />
            </LineChart>
          </ResponsiveContainer>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
